import Vue from 'vue'
import VueRouter from 'vue-router'
import $store from '../store/index'
const login = () => import('@/views/login')

Vue.use(VueRouter)

const routes = [
  // 以下 h5type===3
  {
    path: '/catchFace',
    name: 'catchFace',
    component: () => import('@/views/face/catchFace'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2, 3]
    }
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: () => import('@/views/face/announcements'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2, 3]
    }
  },
  {
    path: '/collectionFaceOK',
    name: 'collectionFaceOK',
    component: () => import('@/views/face/collectionFaceOK'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2, 3]
    }
  },
  {
    path: '/officeCollection',
    name: 'officeCollection',
    component: () => import('@/views/face/officeCollection'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [3]
    }
  },

  // 以下 h5type!==3

  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      h5Type: [1, 2]
    }
  },
  {
    path: '/',
    component: () => import('@/views/index'),
    redirect: '/order',
    meta: {
      keepAlive: false,
      needLogin: false,
      h5Type: [1, 2]
    },
    children: [
      {
        path: '/order',
        name: 'order',
        component: () => import('@/views/order/order'),
        meta: {
          keepAlive: true,
          needLogin: false,
          title: '预约',
          h5Type: [1, 2]
        }
      },
      {
        path: '/message',
        name: 'message',
        component: () => import('@/views/message/message'),
        meta: {
          keepAlive: false,
          needLogin: true,
          title: '消息',
          h5Type: [1, 2]
        }
      },
      {
        path: '/my',
        name: 'my',
        component: () => import('@/views/my/my'),
        meta: {
          keepAlive: false,
          needLogin: true,
          title: '我的',
          h5Type: [1, 2]
        }
      }
    ]
  },
  {
    path: '/historyOrder',
    name: 'historyOrder',
    component: () => import('@/views/my/historyOrder'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '历史预约',
      h5Type: [1, 2]
    }
  },
  {
    path: '/useRecord',
    name: 'useRecord',
    component: () => import('@/views/my/useRecord'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '使用记录',
      h5Type: [1, 2]
    }
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/set/setting'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '设置',
      h5Type: [1, 2]
    }
  },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: () => import('@/views/set/updatePassword'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '修改密码',
      h5Type: [1, 2]
    }
  },
  {
    path: '/bindWechat',
    name: 'bindWechat',
    component: () => import('@/views/set/bindWechat'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '绑定微信',
      h5Type: [1, 2]
    }
  },
  {
    path: '/unBindWechat',
    name: 'unBindWechat',
    component: () => import('@/views/set/unBindWechat'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '解绑微信',
      h5Type: [1, 2]
    }
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('@/views/my/coursees'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '课程',
      h5Type: [1, 2]
    }
  },
  {
    path: '/setAirCondition',
    name: 'setAirCondition',
    component: () => import('@/views/my/setAirCondition'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '设置空调',
      h5Type: [1, 2]
    }
  },
  {
    path: '/appointmentDetails',
    name: 'appointmentDetails',
    component: () => import('@/views/order/appointmentDetails'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '预约详情',
      h5Type: [1, 2]
    }
  },
  {
    path: '/systemMsg',
    name: 'systemMsg',
    component: () => import('@/views/message/systemMsg'),
    meta: {
      keepAlive: false,
      needLogin: true,
      title: '系统消息',
      h5Type: [1, 2]
    }
  },
  {
    path: '/complaint',
    name: 'complaint',
    component: () => import('@/views/message/complaint'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/forceDown',
    name: 'forceDown',
    component: () => import('@/views/message/forceDown'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/failureReportMsg',
    name: 'failureReportMsg',
    component: () => import('@/views/message/failureReportMsg'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/punishNotice',
    name: 'punishNotice',
    component: () => import('@/views/message/punishNotice'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/awardNotice',
    name: 'awardNotice',
    component: () => import('@/views/message/awardNotice'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/adminAward',
    name: 'adminAward',
    component: () => import('@/views/message/adminAward'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/cancelBookByCourse',
    name: 'cancelBookByCourse',
    component: () => import('@/views/message/cancelBookByCourse'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/cancelBook',
    name: 'cancelBook',
    component: () => import('@/views/message/cancelBook'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/failureReport',
    name: 'failureReport',
    component: () => import('@/views/order/failureReport'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/cancelAppointment',
    name: 'cancelAppointment',
    component: () => import('@/views/order/cancelAppointment'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/control',
    name: 'feedback',
    component: () => import('@/views/order/control'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/order/feedback'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/pianoOrder',
    name: 'pianoOrder',
    component: () => import('@/views/order/pianoOrder'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/orderResult',
    name: 'orderResult',
    component: () => import('@/views/order/orderResult'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/backQrcode',
    name: 'backQrcode',
    component: () => import('@/views/my/backQrcode'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/unifiedEntry',
    name: 'unifiedEntry',
    component: () => import('@/views/unifiedEntry/unifiedEntry'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/qrCodeWrap',
    name: 'qrCodeWrap',
    component: () => import('@/views/scanQRCode/qrCodeWrap'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/whiteNameList',
    name: 'whiteNameList',
    component: () => import('@/views/my/whiteNameList'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/continuePiano',
    name: 'continuePiano',
    component: () => import('@/views/order/continuePiano'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/sign_in_out',
    name: 'sign_in_out',
    component: () => import('@/views/scanQRCode/signInOut'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/signInOk',
    name: 'signInOk',
    component: () => import('@/views/scanQRCode/signInOk'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/signOutOk',
    name: 'signOutOk',
    component: () => import('@/views/scanQRCode/signOutOk'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/vip_login',
    name: 'vip_login',
    component: () => import('@/views/vip_login'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  // 开放人脸
  // {
  //   path: '/catchFace',
  //   name: 'catchFace',
  //   component: () => import('@/views/face/catchFace'),
  //   meta: {
  //     keepAlive: false,
  //     needLogin: true
  //   },
  // },
  // {
  //   path: '/announcements',
  //   name: 'announcements',
  //   component: () => import('@/views/face/announcements'),
  //   meta: {
  //     keepAlive: false,
  //     needLogin: true
  //   },
  // },
  // {
  //   path: '/collectionFaceOK',
  //   name: 'collectionFaceOK',
  //   component: () => import('@/views/face/collectionFaceOK'),
  //   meta: {
  //     keepAlive: false,
  //     needLogin: true
  //   },
  // },
  {
    path: '/myFaceInfo',
    name: 'myFaceInfo',
    component: () => import('@/views/face/myFaceInfo'),
    meta: {
      keepAlive: false,
      needLogin: true,
      h5Type: [1, 2]
    }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    meta: {
      h5Type: [1, 2, 3]
    }
  },
  {
    path: '/networkErr',
    name: 'networkErr',
    component: () => import('@/views/networkErr'),
    meta: {
      h5Type: [1, 2, 3]
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/logout'),
    meta: {
      h5Type: [1, 2, 3]
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

async function chkAccess (to) {
  const h5Config = await $store.dispatch('H5CONFIGACTION', to.path === '/login' ? 'force' : '')
  if (h5Config) {
    const type = h5Config.funCfg.h5Type
    return to.meta.h5Type.includes(type)
  } else {
    throw new Error('network Error')
  }
}

router.beforeEach(async (to, from, next) => {
  try {
    const canAccess = await chkAccess(to)
    if (canAccess) {
      // 路由发生变化修改页面title
      if (to.path === '/unifiedEntry' && from.path === '/login') {
        return next()
      }
      if (to.path === '/login') {
        return next()
      }
      next()
    } else {
      next({ name: '404' })
    }
  } catch (e) {
    next({ name: 'networkErr' })
  }
})

const originalPush = router.push

router.push = function (...args) {
  return originalPush.call(this, ...args).catch(error => {
    if (error) {
      console.warn(`exception: ${error}`)
    } else {
      console.warn(`exception ${new Error().stack.replace(/^[\s\S]+?at/, 'at')}`)
    }
  })
}

export default router
